const regex = /\n/ig;

export default html => html.replace(regex, '');
